export default __webpack_public_path__ + "static/documentation-global-header-02-cb6b84bca3614da4cb6444f5228c8d80.jpg";